const emailAddress = 'mailto:gmsxdev@microsoft.com';
const feedbackEmailAddress = 'mailto:gmsxfeedback@microsoft.com';
// tslint:disable-next-line:max-line-length
const bodyPrefix =
  'NOTE: The details of this email are sufficient for developer investigation and can be sent as is. You can provide additional information, screenshots, or attachments if you believe it will assist in the resolution of this escalation.';

// Formats content into a string that is used for a mailto: email link with content (Subject, Body)
export function formatEmailHref(
  subjectErrorType: string,
  tenantDisplayName?: string,
  titleDisplayName?: string,
  subjectType?: string,
  caseDocId?: string,
  tenantId?: string,
  titleId?: string,
  subjectId?: string,
  errorMessage?: string
): string {
  let emailHref: string = emailAddress;

  // Email Subject
  emailHref = emailHref.concat('?subject=Gaming%20Moderation%20-%20');
  emailHref = emailHref.concat(subjectErrorType);
  emailHref = emailHref.concat('%20Error');

  // Only append to Title Display Name and Tenant Display Name are provided
  if (tenantDisplayName != null && titleDisplayName != null) {
    emailHref = emailHref.concat(':%20');
    emailHref = emailHref.concat(tenantDisplayName);
    emailHref = emailHref.concat('%20');
    emailHref = emailHref.concat(titleDisplayName);
  }

  // SubjectType won't always be provided
  if (subjectType != null) {
    emailHref = emailHref.concat('%20');
    emailHref = emailHref.concat(subjectType);
  }

  // Email Body
  emailHref = emailHref.concat('&body=');
  emailHref = emailHref.concat(bodyPrefix);
  emailHref = emailHref.concat('%0D%0A%0D%0A');
  emailHref = emailHref.concat('FEEDBACK%0D%0A');
  emailHref = emailHref.concat('-------------%0D%0A');
  emailHref = emailHref.concat(
    'Comment: <Add any observations or information you feel may be helpful to us in resolving this error>%0D%0A%0D%0A'
  );

  emailHref = emailHref.concat('ERROR%20DETAILS%0D%0A');
  emailHref = emailHref.concat('-------------%0D%0A');

  // Only output if CaseDocId is provided
  if (caseDocId != null) {
    emailHref = emailHref.concat('%0D%0ACaseId:%20');
    emailHref = emailHref.concat(caseDocId);
  }

  // Only output if TitleId and TenantId are provided
  if (tenantId != null && titleId != null) {
    emailHref = emailHref.concat('%0D%0AQueue:%20');
    emailHref = emailHref.concat(tenantId);
    emailHref = emailHref.concat(':');
    emailHref = emailHref.concat(titleId);

    if (subjectType != null) {
      emailHref = emailHref.concat(':');
      emailHref = emailHref.concat(subjectType);
    }
  }

  if (subjectId != null) {
    emailHref = emailHref.concat('%0D%0ASubjectId:%20');
    emailHref = emailHref.concat(subjectId);
  }

  // Only output if error Message is provided
  if (errorMessage != null) {
    emailHref = emailHref.concat('%0D%0AError%20Message:%20');
    emailHref = emailHref.concat(errorMessage);
  }

  return emailHref;
}

export function formatGenericEmailHref(): string {
  let emailHref: string = feedbackEmailAddress;

  // Email Subject
  emailHref = emailHref.concat('?subject=Gaming%20Moderation%20Feedback');

  // Email Body
  emailHref = emailHref.concat('&body=');
  emailHref = emailHref.concat(
    '**NOTE: If this is a tool outage, work with your manager to submit an ICM ticket to the GMSX DevOps team**%0D%0A%0D%0A'
  );
  emailHref = emailHref.concat('Is this a bug or feature request?%0D%0A%0D%0A');
  emailHref = emailHref.concat('<For a bug>%0D%0A');
  emailHref = emailHref.concat('Describe the behavior that you see?%0D%0A');
  emailHref = emailHref.concat(
    '(Include steps to reproduce and screenshots if applicable and the content is not harmful)%0D%0A%0D%0A'
  );
  emailHref = emailHref.concat('What is the behavior that you expect to see?%0D%0A%0D%0A');
  emailHref = emailHref.concat('Describe any steps you took to mitigate the issue? (e.g. Browser refresh)%0D%0A%0D%0A');
  emailHref = emailHref.concat('Is there a workaround?%0D%0A%0D%0A');
  emailHref = emailHref.concat('When did you first see this behavior?%0D%0A%0D%0A');
  emailHref = emailHref.concat('Impact of issue?%0D%0A%0D%0A');
  emailHref = emailHref.concat('<For a feature request>%0D%0A');
  emailHref = emailHref.concat('What is the request that you have?%0D%0A%0D%0A');
  emailHref = emailHref.concat('How will it help you?  What issue will it help to solve?');

  return emailHref;
}
